import React from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
/** UI Components */
import Dialog from "component/atoms/ModalDialog";
import { TabComponents } from "component/atoms/tabComponents";
import { HotkeysPreferences } from "./HotkeysPreferences";
/** Utility libraries */
import classNames from "classnames";

import "./UserPreferences.styl";

const dialogStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",

    /// 아래 스타일은 stylus로 커스텀 되게 수정하자
    backgroundcolor: "#3c3c3c",
  },
};

const propTypes = {
  /**
   * @default 'user-preference-dialog-'
   */
  prefix: PropTypes.string,
  onClose: PropTypes.func,
};

const defaultProps = {
  prefix: "user-preference-dialog-",
  onClose: null,
};

@inject("hotkeyStore")
@observer
class UserPreferencesDialog extends React.Component {
  DIALOG_TITLE = "User Preferences";

  componentWillUnmount() {
    if (!!this.innerElement) {
      this.innerElement.removeEventListener("keydown", this.onKeydownHanlder);
    }
  }
  onKeydownHanlder = (event) => {
    const { onRequestClose } = this.props;
    if (event.keyCode === 27) {
      onRequestClose();
    }
  };

  getTabs() {
    const { defaultHotKeyMap, customHotKeyMap, onRequestClose } = this.props;
    const tabs = [
      {
        name: "Hotkeys",
        Component: HotkeysPreferences,
        customProps: {
          keyMap: customHotKeyMap || {},
          defaultKeyMap: defaultHotKeyMap || {},
          onClose: !!onRequestClose && onRequestClose,
        },
        hidden: false,
      },
    ];
    return tabs;
  }

  render() {
    const { prefix, show, hasCloseButton, onRequestClose } = this.props;
    const tabs = this.getTabs();

    return (
      <Dialog.ModalPortal
        isOpen={show}
        className={classNames(
          "user-preference-dialog__wrapper",
          "noselect",
          "nodrag"
        )}
        backgroundClassName={"message-box-background"}
        style={dialogStyles}
        onRequestClose={onRequestClose}
      >
        <Dialog.DialogLayout.DialogHeader
          inlist=""
          dialogPrefix={prefix}
          closeButton={hasCloseButton}
          onRequestClose={onRequestClose}
        >
          <Dialog.DialogLayout.DialogTitle
            inlist=""
            dialogPrefix={prefix}
            //className={classNames("h4", "text-center")}
          >
            {/* <h4 className="modal-title">{this.DIALOG_TITLE}</h4> */}
          </Dialog.DialogLayout.DialogTitle>
        </Dialog.DialogLayout.DialogHeader>
        <Dialog.DialogLayout.DialogBody
          inlist=""
          dialogPrefix={prefix}
          className="text-center"
        >
          <TabComponents tabs={tabs} customProps={{}} />
        </Dialog.DialogLayout.DialogBody>
      </Dialog.ModalPortal>
    );
  }
}

UserPreferencesDialog.propTypes = propTypes;
UserPreferencesDialog.defaultProps = defaultProps;

export default UserPreferencesDialog;
